import { Button, Input, Select, Form, message, Table, Space, Card, Typography } from 'antd';
import React, { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';

import { HttpClient } from 'helpers/http';

import { NewsletterUsersService } from 'services/newsletter/NewsletterUserService';

import { NewsletterUser, CreateUser } from 'types/services/newsletterUsers';

const { Title } = Typography;
const { Option } = Select;

// ✅ Ensure correct API base URL
const newsletterUsersService = new NewsletterUsersService(
  new HttpClient({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8088/api',
    headers: { 'Content-Type': 'application/json' },
  }),
);

const AddUser = ({ onClose }: { onClose: () => void }) => {
  const [form] = Form.useForm();
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(false);

  // ✅ Fetch Newsletter Users
  const { data: users, isLoading } = useQuery(['listNewsletterUsers'], async () => {
    const response = await newsletterUsersService.list({ page: 1, perPage: 1000 });
    console.log('✅ API Response (Users):', response); // Debugging
    return response; // ✅ Return full response instead of response.data
  });

  // ✅ Mutation for Adding User
  const addUserMutation = useMutation(
    (newUser: CreateUser) => {
      console.log('📤 Sending user data:', newUser); // Debugging
      return newsletterUsersService.create(newUser);
    },
    {
      onSuccess: () => {
        message.success(' Korisnik uspješno dodan!');
        queryClient.invalidateQueries('listNewsletterUsers'); // ✅ Refresh list
        setLoading(false);
        form.resetFields();
      },
      onError: (error) => {
        console.error('❌ Error adding user:', error);
        message.error('⚠️ Greška pri dodavanju korisnika');
        setLoading(false);
      },
    },
  );

  const onFinish = (values: { email: string; type: number }) => {
    setLoading(true);
    console.log('📤 Sending user data:', values);

    addUserMutation.mutate({
      email: values.email,
      userType: values.type, // ✅ Corrected to match backend
    });
  };

  return (
    <div style={{ padding: '20px', maxWidth: '100%', margin: 'auto' }}>
      <Card style={{ padding: '20px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)', borderRadius: '10px' }}>
        <Title level={3} style={{ textAlign: 'center', marginBottom: '20px' }}>
          ✅ Dodaj Korisnika
        </Title>

        <Space direction="vertical" style={{ width: '100%' }}>
          {/* ✅ User Form */}
          <Form layout="vertical" form={form} onFinish={onFinish}>
            <Form.Item name="email" label="📧 Email" rules={[{ required: true, message: 'Unesite email' }]}>
              <Input placeholder="Unesite email" type="email" />
            </Form.Item>

            <Button type="primary" htmlType="submit" block loading={loading} style={{ marginTop: '10px' }}>
              ✅ Dodaj korisnika
            </Button>
          </Form>

          {/* ✅ User List Table */}
          <Table
            dataSource={
              Array.isArray(users)
                ? [...users].sort((a, b) => b.id - a.id) // descending by ID
                : []
            }
            rowKey="id"
            loading={isLoading}
            pagination={{ pageSize: 10 }}
          >
            <Table.Column
              title="📧 Email"
              dataIndex="email"
              key="email"
              render={(email) => {
                console.log('📩 Email:', email); // Debugging
                return email || '❓ No Email';
              }}
            ></Table.Column>
          </Table>
        </Space>
      </Card>
    </div>
  );
};

export default AddUser;
